import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PlayerMutationKeys } from '../../../keys'
import { UpdateChannelRequest, UpdateChannelResponse } from '../../../type'
import { updateChannel } from '../../services'

interface UseMutationUpdateChannelProps {
	id: string
	payload: UpdateChannelRequest
}

export default function useMutationUpdateChannel(
	props?: UseBaseMutationOptions<
		UpdateChannelResponse,
		UseMutationUpdateChannelProps
	>,
) {
	return useMutation({
		mutationKey: [PlayerMutationKeys.UpdateChannel],
		mutationFn: ({ id, payload }) => {
			return updateChannel(id, payload)
		},
		...props,
	})
}
